import React, { createContext, useState, useEffect } from 'react';
import { loginUser, registerUser } from '../services/auth';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setUser({ token });
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const response = await loginUser({ email, password });
      localStorage.setItem('token', response.token);
      setUser({ token: response.token, email });
      return { success: true };
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Errore nel login' };
    }
  };

  const register = async (name, email, password) => {
    try {
      const response = await registerUser({ name, email, password });
      localStorage.setItem('token', response.token);
      setUser({ token: response.token, email });
      return { success: true };
    } catch (error) {
      return { success: false, error: error.response?.data?.error || 'Errore nella registrazione' };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};